import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import ApiClient from "helpers/ApiClient";
const initialState: any = {
  cardData: [],
  status: "",
};

export const getCardsList = createAsyncThunk<any>(
  "getCardsList/setCardsList",
  async (_, thunkAPI) => {
    try {
      const response = await ApiClient.get("feedback?page=1&limit=5000000");
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
const getFeedBackSlice = createSlice({
  name: "getCardsList",
  initialState,
  reducers: {
    setFeedBacksList(state, action) {
      state.cardData = action.payload;
    },
    addFeedback(state, action) {
      ApiClient.post("feedback/add", action.payload);
    },
    addComment(state, action) {
      ApiClient.post("feedback/comments/add", action.payload);
      return state;
    },
    deleteComment(state, action) {
      ApiClient.delete("feedback/comments/delete", { data: action.payload });
      getCardsList();
    },
    updateComment(state, action) {
      ApiClient.put("feedback/comments/update", action.payload);
      getCardsList();
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCardsList.pending, (state) => {
      state.status = "pending";
    });
    builder.addCase(
      getCardsList.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.cardData = action.payload;
        state.status = "succeeded";
      }
    );
    builder.addCase(
      getCardsList.rejected,
      (state, action: PayloadAction<any>) => {
        state.status = "failed";
      }
    );
  },
});

export const {
  setFeedBacksList,
  addFeedback,
  addComment,
  deleteComment,
  updateComment,
} = getFeedBackSlice.actions;
export default getFeedBackSlice;
